module.exports = __webpack_public_path__ + "static/media/next-colored.820dea44.svg";